import { render, staticRenderFns } from "./NewVersions.vue?vue&type=template&id=7a15380d&scoped=true"
import script from "./NewVersions.vue?vue&type=script&lang=js"
export * from "./NewVersions.vue?vue&type=script&lang=js"
import style0 from "./NewVersions.vue?vue&type=style&index=0&id=7a15380d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15380d",
  null
  
)

export default component.exports